import "styles/components/recent-orders.scss";
import useHandoff from "hooks/useHandoff";

import { ReactComponent as AddFavouriteIcon } from "static/images/favourite-add.svg";
import { ReactComponent as RemoveFavouriteIcon } from "static/images/favourite.svg";
import { ReactComponent as RailcardIcon } from "static/images/railcard.svg";
import { ReactComponent as LoadingIcon } from "static/images/loading.svg";


import { checkIfFavourite } from "lib/favourites";

const RecentOrder = (props) => {
  const { order, favourites, loading } = props;
  const { duration, origin, destination, ticketType, adults, children, railcard } = order;

  const favouriteData = favourites?.find((fav) => checkIfFavourite(order, fav));
  const isFavourite = favouriteData;
  const adultsInfo = adults ? `${ticketType.name === 'Flexi Season' ? 1 : adults}x Adult` : "";
  const childrenInfo = children ? `${children}x children` : "";
  const railcardInfo = railcard ? (
    <div>
      <RailcardIcon /> {railcard.name}
    </div>
  ) : (
    ""
  );

  const Icon = loading ? LoadingIcon : isFavourite ? RemoveFavouriteIcon : AddFavouriteIcon;

  const onHandoff = useHandoff();

  const toggleFavourite = () => {
    props.toggleFavourite(order, favouriteData?.id, props.i);
  };

  // belongs in src/contstants but there is some bug with imports/exports
  const SeasonTicketDurations = {
    P7D: 'Weekly',
    P1M: 'Monthly',
    P1Y: 'Annual',
    P12M: 'Annual',
    P1Y1D: 'Annual', // leap year??
  };

  let ticketName = ticketType.name;

  if (ticketType.isSeason && ticketType.name !== 'Flexi Season') {
    ticketName = `${SeasonTicketDurations[duration] || 'Custom'} ${ticketType.name}`
  }

  return (
    <div className="otrl-jp__recent-order" key={props.i}>
      <header>
        <p>
          <b>{origin.name}</b> to <b>{destination.name}</b>
        </p>

        <div className="otrl-jp__favourites-empty__button__favourite-icon-container">
          <Icon
            className="otrl-jp__favourites-empty__button__favourite-icon"
            onClick={toggleFavourite}
          />
        </div>
      </header>

      <p className="otrl-jp__recent-order__ticket-type">{ticketName}</p>

      <div className="otrl-jp__recent-order__passenger-info">
        {`${adultsInfo} ${childrenInfo}`} {railcardInfo}
      </div>

      <button
        className="otrl-jp__button otrl-jp__tickets__submit"
        onClick={() => onHandoff(order)}
      >
        Buy again
      </button>
    </div>
  );
};

export default RecentOrder;
